var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import orderBy from 'lodash.orderby';
import groupBy from 'lodash.groupby';

var getGroup = function getGroup(groups, start, dateKey) {
  return groups.find(function (g) {
    return g[dateKey].isSame(start, 'day');
  });
};

export var addMissingDates = function addMissingDates(groups, _ref) {
  var dateKey = _ref.dateKey,
      entityKey = _ref.entityKey;
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    count: 0
  };
  var result = [];
  if (!groups.length) return result;
  var start = groups[0][dateKey];
  var end = groups[groups.length - 1][dateKey];

  if (!entityKey) {
    var copyStart = start.clone();

    while (copyStart.isSameOrBefore(end)) {
      var _extends2;

      var group = getGroup(groups, copyStart, dateKey);
      result.push(group || _extends((_extends2 = {}, _extends2[dateKey] = copyStart.clone(), _extends2), props));
      copyStart.add(1, 'days');
    }

    return result;
  }

  var groupByEntities = groupBy(groups, function (x) {
    return x[entityKey];
  });
  Object.keys(groupByEntities).forEach(function (groupKey) {
    var groupByDates = groupByEntities[groupKey];
    var copyStart = start.clone();

    while (copyStart.isSameOrBefore(end)) {
      var _extends3;

      var _group = getGroup(groupByDates, copyStart, dateKey);

      result.push(_group || _extends((_extends3 = {}, _extends3[dateKey] = copyStart.clone(), _extends3[entityKey] = groupKey, _extends3), props));
      copyStart.add(1, 'days');
    }
  });
  return orderBy(result, [function (x) {
    return x[dateKey];
  }, function (x) {
    return x[entityKey];
  }], ['asc', 'asc']);
};